import { useRMVCurrency } from './useCurrency';

export const useStableExchangeRate = (
  selectedCurrencyId: number | null,
  exchangeRate: number,
  isAuctionHouse: boolean
): number => {
  const rmvCurrency = useRMVCurrency();

  if (selectedCurrencyId === null || exchangeRate === 0 || !isAuctionHouse) {
    return 1;
  }

  if (!rmvCurrency || selectedCurrencyId === rmvCurrency.id) {
    return 1;
  }

  return Math.pow(10, rmvCurrency.decimal) / exchangeRate;
};
